module.exports = __webpack_public_path__ + "static/media/0010_Small.ad12c275.jpg";